module.exports = require("react-switch");